// Faq accordion at the time one open

document.addEventListener("DOMContentLoaded", function () {
  // Select all the accordion-custom elements within accordion-box
  var accordionCustoms = document.querySelectorAll(
    ".accordion-box .accordion-custom"
  );

  // Loop through each accordion-custom element
  accordionCustoms.forEach(function (accordionCustom) {
    // Find the summary and content within each accordion-custom
    var title = accordionCustom.querySelector("summary");
    var content = accordionCustom.querySelector(".accordion__content");
    var prose = content.querySelector(".prose");
    var proseHeight = prose.clientHeight + 20; // Include padding or margin if needed

    // Add click event listener to the summary
    title.addEventListener("click", function () {
      var isActive = accordionCustom.classList.contains("active");

      // Collapse all accordions
      accordionCustoms.forEach(function (acc) {
        acc.classList.remove("active");
        acc.querySelector(".accordion__content").style.height = "0px";
      });

      // Expand the clicked accordion if it was not active
      if (!isActive) {
        accordionCustom.classList.add("active");
        content.style.height = proseHeight + "px";
      }
    });
  });
});

// collection page description trim

function limitWords(selector, wordLimit) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => {
    const words = element.innerText.split(" ");
    if (words.length > wordLimit) {
      element.innerText = words.slice(0, wordLimit).join(" ") + "...";
    }
  });
}

limitWords(".text-limited-js", 5); // Change 20 to the number of words you want to show

// desktop menu active class

document.addEventListener("DOMContentLoaded", function () {
  var path = window.location.href; // Get the current URL

  document
    .querySelectorAll(".panel-list__wrapper ul li a")
    .forEach(function (anchor) {
      if (anchor.href === path) {
        anchor.classList.add("active");
      }
    });
});

// mobile menu active class

document.addEventListener("DOMContentLoaded", function () {
  var path = window.location.href; // Get the current URL

  document.querySelectorAll(".contents li a").forEach(function (anchor) {
    if (anchor.href === path) {
      anchor.classList.add("active");
    }
  });
});

// FAQ section start from here

$(".faq_custom__section .accordion-header").click(function () {
  $(this).toggleClass("active");
  $(this).next(".accordion-content").slideToggle(200);
  $(".accordion-content").not($(this).next()).slideUp(200);
  $(".accordion-header").not($(this)).removeClass("active");
});

// FAQ section end.

// Product Hero Slider Section code start from here.

function updateProgressBar(currentSlide, slideCount) {
  var progressPercentage = ((currentSlide + 1) / slideCount) * 100;
  $(".progress-bar .active").css("width", progressPercentage + "%");
}

function updateCounterOnSlideChange(currentSlide, slideCount) {
  var currentSlideNumber = (currentSlide + 1).toString().padStart(2, "0");
  var totalSlidesNumber = slideCount.toString().padStart(2, "0");

  // Update the text of the counter
  $(".slider-counter").html(
    '<span class="activee">' +
      currentSlideNumber +
      "</span>" +
      " / " +
      totalSlidesNumber
  );
}

$(".slick__sliderr").slick({
  slidesToShow: 1.3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: ".prev-arrow1",
  nextArrow: ".next-arrow1",
  adaptiveHeight: false,
  centerMode: false,
  // centerPadding: '80px',
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        arrows: true,
      },
    },
  ],
});

// Update counter on slide change
$(".slick__sliderr").on("afterChange", function (event, slick, currentSlide) {
  updateCounterOnSlideChange(currentSlide, slick.slideCount);
  updateProgressBar(currentSlide, slick.slideCount);
});

// Optionally, you can set the counter on the initial slide when the slider is initialized
$(".slick__sliderr").on("init", function (event, slick) {
  updateCounterOnSlideChange(slick.currentSlide, slick.slideCount);
  updateProgressBar(currentSlide, slick.slideCount);
});

// Product Hero Slider Section code End.

// Dispatch Event on Button Click
// const buttons = document.querySelectorAll(
//   'button[aria-controls="booking-drawer"]'
// );

// buttons.forEach((button) => {
//   button.addEventListener("click", () => {
//     const customEvent = new CustomEvent("openDatepicker", {
//       detail: {},
//     });

//     button.dispatchEvent(customEvent);
//   });

//   button.addEventListener("openDatepicker", (event) => {
//     const productCard = button.closest("product-card");

//     if (productCard) {
//       const variantId = productCard.getAttribute("data-variant-id");

//       const bookingDrawer = document.querySelector("booking-drawer");

//       if (bookingDrawer) {
//         const hiddenInput = bookingDrawer.querySelector('input[name="id"]');
//         if (hiddenInput) {
//           hiddenInput.value = variantId;
//         }
//       }
//     }
//   });

//   // Event listener for custom event to initialize Flatpickr
//   button.addEventListener("openDatepicker", (event) => {
//     flatpickr.localize(flatpickr.l10ns.de);
//     flatpickr("#datepicker", {
//       enableTime: false, // Disables time selection
//       dateFormat: "Y-m-d", // Custom date format with time
//       // defaultDate: new Date().fp_incr(3), // Sets the current date and time as default
//       minDate: new Date().fp_incr(3),
//       locale: {
//         firstDayOfWeek: 1, // Sets Monday as the first day of the week
//       },
//       inline: true, // Show the datepicker inline,
//       altInput: true,
//       altInputClass: "hidden",
//       altFormat: "d.m.Y",
//       onReady: function (selectedDates, dateStr, instance) {
//         const chosenDate = instance.altInput.value;
//         document.querySelector('input[name="properties[Dein Datum]"]').value =
//           chosenDate;
//       },
//       onChange: function (selectedDates, dateStr, instance) {
//         const chosenDate = instance.altInput.value;
//         document.querySelector('input[name="properties[Dein Datum]"]').value =
//           chosenDate;

//         const today = new Date();
//         const selectedDate = selectedDates[0];

//         const diffInTime = selectedDate.getTime() - today.getTime();
//         const diffInDays = Math.ceil(diffInTime / (1000 * 3600 * 24));

//         const messageDiv = document.getElementById("availability-message");

//         const selectedDay = selectedDate.getDay();

//         if (diffInDays >= 3 && diffInDays <= 5) {
//           messageDiv.innerHTML = `<div class="banner banner--warning  justify-center"><svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-warning" style="--icon-height: 18px" viewBox="0 0 18 18">
//           <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
//           <path d="M7.98347 10.156V4.504H9.99947V10.156H7.98347ZM10.1675 11.98C10.1675 12.14 10.1355 12.292 10.0715 12.436C10.0155 12.572 9.93147 12.692 9.81947 12.796C9.71547 12.892 9.59147 12.968 9.44747 13.024C9.30347 13.088 9.15147 13.12 8.99147 13.12C8.83147 13.12 8.67947 13.092 8.53547 13.036C8.39947 12.98 8.27947 12.9 8.17547 12.796C8.07147 12.692 7.98747 12.572 7.92347 12.436C7.85947 12.3 7.82747 12.152 7.82747 11.992C7.82747 11.84 7.85547 11.696 7.91147 11.56C7.97547 11.416 8.05947 11.292 8.16347 11.188C8.26747 11.084 8.39147 11.004 8.53547 10.948C8.67947 10.884 8.83147 10.852 8.99147 10.852C9.15147 10.852 9.30347 10.884 9.44747 10.948C9.59147 11.004 9.71547 11.084 9.81947 11.188C9.93147 11.284 10.0155 11.404 10.0715 11.548C10.1355 11.684 10.1675 11.828 10.1675 11.98Z" fill="#ffffff"></path>
//         </svg>Sei schnell! Nur noch wenige Fotoboxen verfügbar</div>`;
//         } else if (
//           diffInDays >= 6 &&
//           diffInDays <= 45 &&
//           (selectedDay === 5 || selectedDay === 6)
//         ) {
//           messageDiv.innerHTML = `<div class="banner banner--warning  justify-center"><svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-warning" style="--icon-height: 18px" viewBox="0 0 18 18">
//           <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
//           <path d="M7.98347 10.156V4.504H9.99947V10.156H7.98347ZM10.1675 11.98C10.1675 12.14 10.1355 12.292 10.0715 12.436C10.0155 12.572 9.93147 12.692 9.81947 12.796C9.71547 12.892 9.59147 12.968 9.44747 13.024C9.30347 13.088 9.15147 13.12 8.99147 13.12C8.83147 13.12 8.67947 13.092 8.53547 13.036C8.39947 12.98 8.27947 12.9 8.17547 12.796C8.07147 12.692 7.98747 12.572 7.92347 12.436C7.85947 12.3 7.82747 12.152 7.82747 11.992C7.82747 11.84 7.85547 11.696 7.91147 11.56C7.97547 11.416 8.05947 11.292 8.16347 11.188C8.26747 11.084 8.39147 11.004 8.53547 10.948C8.67947 10.884 8.83147 10.852 8.99147 10.852C9.15147 10.852 9.30347 10.884 9.44747 10.948C9.59147 11.004 9.71547 11.084 9.81947 11.188C9.93147 11.284 10.0155 11.404 10.0715 11.548C10.1355 11.684 10.1675 11.828 10.1675 11.98Z" fill="#ffffff"></path>
//         </svg>Sei schnell! Nur noch wenige Fotoboxen verfügbar</div>`;
//         } else if (diffInDays >= 6) {
//           messageDiv.innerHTML = `<div class="banner banner--success  justify-center"><svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="offset-icon icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
//           <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
//           <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
//         </svg>Yay! Deine Fotobox ist verfügbar</div>`;
//         } else {
//           messageDiv.textContent = "";
//         }
//       },
//     });
//   });
// });

/* Save URL Params */
function getUrlParametersAsString() {
  const params = new URLSearchParams(window.location.search);
  const paramArray = [];
  params.forEach((value, key) => {
    paramArray.push(`${key}=${value}`);
  });
  return paramArray.join("&");
}

function saveParametersToSessionStorage() {
  const existingParams = sessionStorage.getItem("url_parameters");

  if (!existingParams) {
    const paramString = getUrlParametersAsString();
    if (paramString) {
      sessionStorage.setItem("url_parameters", paramString);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  saveParametersToSessionStorage();
});

const inqButtons = document.querySelectorAll(
  'button[aria-controls="inquiry-drawer"]'
);

inqButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const sku = button.getAttribute("data-sku");

    const customEvent = new CustomEvent("openInquiryDrawer", {
      detail: {
        button: button,
        timestamp: Date.now(),
        sku: sku,
      },
    });

    document.dispatchEvent(customEvent);
  });
});

document.addEventListener("openInquiryDrawer", (event) => {
  writeParamsToInput();
  selectRadioInputBySku(event.detail.sku);
});

function writeParamsToInput() {
  const paramString = sessionStorage.getItem("url_parameters");

  const inputElement = document.querySelector(
    '#inquiry-drawer input[data-default-value="url_params"]'
  );

  if (inputElement) {
    inputElement.value = paramString ? paramString : "";
  }
}

function selectRadioInputBySku(sku) {
  const formBuilder = document.querySelector("#inquiry-drawer");
  if (formBuilder) {
    const radioInputs = formBuilder.querySelectorAll('input[type="radio"]');
    radioInputs.forEach((radio) => {
      if (radio.value === sku) {
        radio.click();
        radio.checked = true;
      }
    });
  }
}

// // Selektiere die .b2b-selector-Elemente
// const b2bSelector = document.querySelector(".b2b-selector");

// // Überprüfen, ob die .b2b-selector existiert
// if (b2bSelector) {
//   // Füge einen Event-Listener für Änderungen an den Radio-Inputs hinzu
//   b2bSelector.addEventListener("change", (event) => {
//     const target = event.target;

//     // Prüfe, ob das geänderte Element ein Radio-Input ist und den Wert "b2b" hat
//     if (target.type === "radio" && target.value === "b2b") {
//       console.log('Radio mit Wert "b2b" wurde ausgewählt.');
//     }
//   });
// }

document.addEventListener("openInquiryDrawer", function () {
  // Selektiere das Input-Element innerhalb des .datepicker-Containers
  const datepickerInput = document.querySelector(".datepicker input");

  // Überprüfe, ob das Element existiert
  if (datepickerInput) {
    const customContainer = document.querySelector(".datepicker");
    // Initialisiere Flatpickr auf dem ausgewählten Element
    flatpickr.localize(flatpickr.l10ns.de);
    flatpickr(datepickerInput, {
      enableTime: false, // Zeitwahl deaktivieren
      dateFormat: "d.m.Y", // Datumsformat
      minDate: new Date().fp_incr(3),
      inline: true,
      appendTo: customContainer,
      locale: {
        firstDayOfWeek: 1, // Montag als ersten Wochentag setzen
      },
      onChange: function (selectedDates, dateStr, instance) {
        // console.log("Ausgewähltes Datum:", dateStr);
      },
    });
  }
});
